<p-toast position="top-right"></p-toast>
<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>{{setLabel("memberAccountLabel")}}</h1>
      <div class="ui-g-12">
        <p-toolbar>
          <div class="ui-toolbar-group-left">
            <button routerLink="/accounts" pButton type="button" [label]='setLabel("goBackBtnLabel")' icon="pi pi-arrow-left"></button>
            <button (click)="showDialog()" pButton type="button" [label]='setLabel("addFeeBtnLabel")' icon="pi pi-save"
              class="ui-button-success"></button>
            <button pButton type="button" (click)="printAll()" [label]='setLabel("printAllBtnLabel")' icon="pi pi-print"
              class="ui-button-info"></button>
          </div>
        </p-toolbar>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6">
          <div class="ui-g-12">{{setLabel("name:Label")}} {{member.name}}</div>
          <div class="ui-g-12">{{setLabel("email:Label")}} {{member.email}}</div>
          <div class="ui-g-12">{{setLabel("membershipNumber:Label")}} {{member.tagNumber}}</div>
          <div class="ui-g-12">{{setLabel("contact:Label")}} {{member.contactDetail.contact}}</div>
        </div>
        <div class="ui-g-6" style="text-align: end;">
          <img [src]="member.profile" style="width:30% " />
        </div>
      </div>
      <div class="ui-g-12">
        <p-table [value]="member.feeDetails" [paginator]="true" [rows]="10" [responsive]="true">
          <ng-template pTemplate="caption">
            {{setLabel("memberFeeDetailsLabel")}}
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{setLabel("invoiceLabel")}}</th>
              <th>{{setLabel("paidLabel")}}</th>
              <th>{{setLabel("dateLabel")}}</th>
              <th>{{setLabel("statusLabel")}}</th>
              <th>{{setLabel("actionsLabel")}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>{{rowData.invoice}}</td>
              <td>{{rowData.pay}}</td>
              <td>{{rowData.date}}</td>
              <td>{{rowData.status}}</td>
              <td>
                <button pButton type="button" class="ui-button-success ui-button" icon="fa fa-money"
                  (click)="printSelected(rowData)"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{setLabel("feeTotal:Label")}} {{feeTotal}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td>
                {{setLabel("noRecordsFoundLabel")}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</div>
<p-dialog [header]='setLabel("payFundHeaderLabel")' [(visible)]="dialogVisibility">
  <form #feeForm="ngForm">
    <div class="ui-g-12 ui-md-12">
      <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon">{{setLabel("PKRLabel")}}</span>
        <input type="number" required pattern="[0-9]+" autocomplete="off" pInputText [placeholder]='setLabel("pricePlaceholderLabel")' name="fund"
          [(ngModel)]="fund.pay" #pay="ngModel"
          [ngClass]="pay.invalid && (pay.dirty || pay.touched) ? 'errorInput' : '' ">
        <span class="ui-inputgroup-addon">.00</span>
      </div>
      <div *ngIf="pay.invalid && (pay.dirty || pay.touched)">
        <div *ngIf="pay.errors.required" class="errorShow">
          {{setLabel("pleaseEnterFeeCorrectlyErroeLabel")}}
        </div>
        <div *ngIf="pay.errors.pattern" class="errorShow">
          {{setLabel("pleaseEnterFeeCorrectlyErroeLabel")}}
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-12">
      <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon">{{setLabel("commentLabel")}}</span>
        <textarea rows="5" cols="80" [(ngModel)]="member.description" pInputTextarea></textarea>
      </div>
    </div>
    <p-footer>
      <button (click)="addFund()" [disabled]="!feeForm.valid" pButton type="button" [label]='setLabel("saveBtnLabel")' icon="pi pi-save"
        class="ui-button-success"></button>
    </p-footer>
  </form>
</p-dialog>
<div id="invoice" style="display: none;">
  <div class="invoice-box" style="padding: 0px !important; max-width: 270px !important; margin: 0 !important;">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="4">
          <table>
            <tr>
              <td class="title">
                <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                  alt="Company Logo" style="width:100%; max-width:200px;margin-left: 20px;">
              </td>
            </tr>
            <tr>
              <td style="text-align: center !important;">
                <small>{{setLabel("cell:Label")}} {{branch.phone}}<br />{{branch.address}}</small><br />
                {{setLabel("created:Label")}} {{fundInvoice.date | date: 'dd/MM/yyyy'}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="information">
        <td colspan="4">
          <table>
            <tr>
              <td></td>
              <td style="text-align: left !important">
                {{member.name}}<br> {{setLabel("membershipNumber:Label")}}{{member.tagNumber}}<br>
                {{member.email}}<br> {{member.contactDetail.contact}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="heading">
        <td>{{setLabel("invoiceLabel")}}</td>
        <td>{{setLabel("payLabel")}}</td>
        <td>{{setLabel("dateLabel")}}</td>
        <td>{{setLabel("statusLabel")}}</td>
      </tr>
      <tr class="item" v-for="item in items">
        <td style="padding: 0 !important;">{{fundInvoice.invoice}}</td>
        <td style="padding: 0 !important;">{{setLabel("PKRLabel")}} {{fundInvoice.pay}}</td>
        <td style="padding: 0 !important;">{{fundInvoice.date}}</td>
        <td style="padding: 0 !important;">{{fundInvoice.status}}</td>
      </tr>
    </table>
    <br>
    <div style="text-align: center;font-size:smaller;">
      <!-- GRITFIT STUDIO 3rd Floor Al-Karim Plaza F-11 Markaz Islamabad -->
      {{branch.address}}
    </div>
    <div style="text-align: center;font-size:smaller;">
      {{setLabel("contact:Label")}} {{branch.phone}}
    </div>
    <hr>
    <div class="logoDiv" style="text-align:center;font-size:smaller;">
      {{setLabel("poweredByLabel")}} &nbsp;
      <a href="http://tecfolk.com/" target="_blank"><img style="width:66px;"
          src="http://tecfolk.com/Content/img/tecfolk-logo-recipt.png" alt=""></a>
    </div>
    <div style="text-align: center;font-size: smaller;">
      {{setLabel("contact:0332-5478182Label")}}
    </div>
  </div>
</div>
<div id="allInvoice" style="display: none;">
  <div class="invoice-box">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="4">
          <table>
            <tr>
              <td class="title">
                <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                  alt="Company Logo" style="width:100%; max-width:300px;">
              </td>
              <td>
                {{setLabel("created:Label")}} {{fund.date | date: 'dd/MM/yyyy'}}
              </td>
            </tr>
            <tr>
              <small>{{setLabel("cell:Label")}} {{branch.phone}}<br />{{branch.address}}</small>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="information">
        <td colspan="4">
          <table>
            <tr>
              <td></td>
              <td>
                {{member.name}}<br> {{setLabel("membershipNumber:Label")}}{{member.tagNumber}}<br>
                {{member.email}}<br> {{member.contactDetail.contact}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="heading">
        <td>{{setLabel("invoiceLabel")}}</td>
        <td>{{setLabel("payLabel")}}</td>
        <td>{{setLabel("dateLabel")}}</td>
        <td>{{setLabel("statusLabel")}}</td>
      </tr>
      <tr class="item" *ngFor="let item of member.feeDetails">
        <td>{{item.invoice}}</td>
        <td>{{setLabel("PKRLabel")}} {{item.pay}}</td>
        <td>{{item.date}}</td>
        <td>{{item.status}}</td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td>{{setLabel("feeTotal:Label")}} {{feeTotal}}</td>
      </tr>
    </table>
  </div>
</div>